import React from "react";
import Page from "components/Page";
import { CompaniesListProps } from "./Companies.types";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const Companies = lazyWithRetry(() => import("./CompaniesList"));

export default (props: CompaniesListProps) => (
  <Page>
    <Companies {...props} />
  </Page>
);
